function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
function sortRecipeRegistrations(registrations) {
    return [...registrations].sort((left, right) => {
        const componentIdCompare = compareStrings(left.componentId, right.componentId);
        if (componentIdCompare !== 0) {
            return componentIdCompare;
        }
        return compareStrings(left.registrationId, right.registrationId);
    });
}
function sortStructureRegistrations(registrations) {
    return [...registrations].sort((left, right) => {
        const componentIdCompare = compareStrings(left.componentId, right.componentId);
        if (componentIdCompare !== 0) {
            return componentIdCompare;
        }
        const extensionPointCompare = compareStrings(left.extensionPoint, right.extensionPoint);
        if (extensionPointCompare !== 0) {
            return extensionPointCompare;
        }
        return compareStrings(left.registrationId, right.registrationId);
    });
}
export function createExtensionIndex() {
    const recipeEntriesByComponentId = new Map();
    const structureEntriesByComponentId = new Map();
    const getRecipeExtensions = (componentId) => {
        if (componentId) {
            return sortRecipeRegistrations(recipeEntriesByComponentId.get(componentId) ?? []);
        }
        const allEntries = Array.from(recipeEntriesByComponentId.values()).flat();
        return sortRecipeRegistrations(allEntries);
    };
    const getStructureExtensions = (componentId) => {
        if (componentId) {
            return sortStructureRegistrations(structureEntriesByComponentId.get(componentId) ?? []);
        }
        const allEntries = Array.from(structureEntriesByComponentId.values()).flat();
        return sortStructureRegistrations(allEntries);
    };
    const mergeRecipeExtensions = (componentId) => {
        const mergedVariants = {};
        const mergedTokens = {};
        const orderedEntries = getRecipeExtensions(componentId);
        for (const entry of orderedEntries) {
            const variantAxes = entry.payload.variants ?? {};
            for (const axis of Object.keys(variantAxes).sort(compareStrings)) {
                const values = variantAxes[axis];
                const targetAxis = mergedVariants[axis] ?? {};
                for (const value of Object.keys(values).sort(compareStrings)) {
                    targetAxis[value] = values[value];
                }
                mergedVariants[axis] = targetAxis;
            }
            const tokens = entry.payload.tokens ?? {};
            for (const tokenPath of Object.keys(tokens).sort(compareStrings)) {
                mergedTokens[tokenPath] = tokens[tokenPath];
            }
        }
        return {
            variants: mergedVariants,
            tokens: mergedTokens,
        };
    };
    const clear = () => {
        recipeEntriesByComponentId.clear();
        structureEntriesByComponentId.clear();
    };
    return {
        registerRecipeExtension(entry) {
            const entries = recipeEntriesByComponentId.get(entry.componentId) ?? [];
            entries.push(entry);
            recipeEntriesByComponentId.set(entry.componentId, entries);
        },
        registerStructureExtension(entry) {
            const entries = structureEntriesByComponentId.get(entry.componentId) ?? [];
            entries.push(entry);
            structureEntriesByComponentId.set(entry.componentId, entries);
        },
        getRecipeExtensions,
        getStructureExtensions,
        mergeRecipeExtensions,
        clear,
    };
}
/** @deprecated Use createExtensionIndex. */
export const createExtensionRegistry = createExtensionIndex;
export const extensionIndex = createExtensionIndex();
/** @deprecated Use extensionIndex. */
export const extensionRegistry = extensionIndex;
//# sourceMappingURL=extension-registry.js.map